import styled, { css } from 'styled-components';
import { Box, inputMediumStyles } from '@bechtel/gds';
import { SearchField } from '@bechtel/client-common';

export const BoxStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  p: { sm: '500' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    overflow: hidden auto;
    width: 300px;
    height: calc(100vh - 125px);
  `}
`;

export const SearchFieldComponentStyled = styled(SearchField)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
  `}
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
`;

export const EmptyStatusContainer = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  background-color: ${({ theme }) => theme.colors.white};
  height: 100%;
  width: 100%;
  text-align: center;
  opacity: 70%;
`;

export const EmptyTextContainer = styled(Box).attrs({
  mt: { sm: '700' },
})`
  color: ${({ theme }) => theme.colors.grey[1000]};
  opacity: 86%;
`;
